import React, { useState, useEffect } from "react";
import "./MensajeWhatsapp.css";
import baseURL from "../../url";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MENSAJE_DEFAULT = `¡Hola! 🌟 Mi pedido es el N°{idPedido}
{productosDetails}
👤 Nombre: {nombre}

📱 Teléfono: {telefono}

📦 Entrega: {entrega}

💵 Forma de pago: {pago}

📌 Pago al recibirlo: {pagoRecibir}

🏷 Código de descuento: {codigo}

✅ Nota: {nota}

*Total: {moneda} {total}*`;

const VARIABLES = [
    { key: "{idPedido}",         desc: "Número de pedido" },
    { key: "{productosDetails}", desc: "Lista de productos" },
    { key: "{nombre}",           desc: "Nombre del cliente" },
    { key: "{telefono}",         desc: "Teléfono del cliente" },
    { key: "{entrega}",          desc: "Tipo de entrega / dirección" },
    { key: "{pago}",             desc: "Forma de pago" },
    { key: "{pagoRecibir}",      desc: "Pago al recibirlo (Si/No)" },
    { key: "{codigo}",           desc: "Código de descuento" },
    { key: "{nota}",             desc: "Nota del pedido" },
    { key: "{moneda}",           desc: "Símbolo de moneda" },
    { key: "{total}",            desc: "Total del pedido" },
];

export default function MensajeWhatsapp() {
    const [mensaje, setMensaje]     = useState("");
    const [loading, setLoading]     = useState(true);
    const [guardando, setGuardando] = useState(false);

    // ── Cargar plantilla desde la BD al montar ──────────────────────────────
    useEffect(() => {
        fetch(`${baseURL}/mensaje-whatsapp.php`)
            .then(r => r.json())
            .then(data => {
                if (data?.ok && data?.data?.mensaje) {
                    setMensaje(data.data.mensaje);
                } else {
                    setMensaje(MENSAJE_DEFAULT);
                }
            })
            .catch(() => {
                setMensaje(MENSAJE_DEFAULT);
                toast.error("No se pudo cargar el mensaje guardado");
            })
            .finally(() => setLoading(false));
    }, []);

    // ── Guardar plantilla en la BD ──────────────────────────────────────────
    const guardar = async () => {
        setGuardando(true);
        try {
            const res = await fetch(`${baseURL}/mensaje-whatsapp.php`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mensaje }),
            });
            const data = await res.json();
            if (data?.ok) {
                toast.success("✅ Mensaje guardado correctamente");
            } else {
                toast.error("Error al guardar: " + (data?.error || "desconocido"));
            }
        } catch {
            toast.error("Error de conexión al guardar");
        } finally {
            setGuardando(false);
        }
    };

    // ── Restaurar plantilla default ─────────────────────────────────────────
    const restaurarDefault = () => {
        setMensaje(MENSAJE_DEFAULT);
        toast.info("Plantilla restaurada. Guardá para aplicar los cambios.");
    };

    // ── Insertar variable donde está el cursor ──────────────────────────────
    const insertarVariable = (variable) => {
        const textarea = document.getElementById("textarea-plantilla");
        if (textarea) {
            const start = textarea.selectionStart;
            const end   = textarea.selectionEnd;
            const nuevo = mensaje.substring(0, start) + variable + mensaje.substring(end);
            setMensaje(nuevo);
            // Reposicionar cursor después de la variable insertada
            setTimeout(() => {
                textarea.selectionStart = textarea.selectionEnd = start + variable.length;
                textarea.focus();
            }, 0);
        } else {
            setMensaje(prev => prev + variable);
        }
    };

    if (loading) {
        return (
            <div className="contenedor-whatsapp">
                <p style={{ padding: "30px", textAlign: "center" }}>Cargando configuración...</p>
            </div>
        );
    }

    return (
        <div className="contenedor-whatsapp">
            <ToastContainer />

            <h2>📲 Mensaje de WhatsApp al cliente</h2>
            <p className="descripcion-wsp">
                Este es el mensaje que se enviará al cliente cuando confirme su pedido.
                Usá las <strong>variables</strong> para incluir datos dinámicos del pedido.
            </p>

            {/* ── Variables disponibles (chips clicables) ── */}
            <h3>Variables disponibles</h3>
            <p className="descripcion-wsp">
                Hacé clic en una variable para insertarla donde esté el cursor en el mensaje.
            </p>
            <div className="grid-variables">
                {VARIABLES.map(({ key, desc }) => (
                    <button
                        key={key}
                        className="chip-variable"
                        onClick={() => insertarVariable(key)}
                        title={`Insertar ${key}`}
                        type="button"
                    >
                        <span className="chip-key">{key}</span>
                        <span className="chip-desc">{desc}</span>
                    </button>
                ))}
            </div>

            {/* ── Textarea principal ── */}
            <label style={{ marginTop: "20px", display: "block" }}>Plantilla del mensaje *</label>
            <textarea
                id="textarea-plantilla"
                className="textarea-mensaje"
                rows={16}
                value={mensaje}
                onChange={e => setMensaje(e.target.value)}
                placeholder="Escribí la plantilla del mensaje aquí..."
            />

            {/* ── Botones de acción ── */}
            <div className="btns-wsp">
                <button
                    className="btn-guardar-wsp"
                    onClick={guardar}
                    disabled={guardando}
                    type="button"
                >
                    {guardando ? "Guardando..." : "💾 Guardar mensaje"}
                </button>
                <button
                    className="btn-restaurar-wsp"
                    onClick={restaurarDefault}
                    type="button"
                >
                    🔄 Restaurar default
                </button>
            </div>

            {/* ── Vista previa ── */}
            <h3>Vista previa</h3>
            <pre className="preview-mensaje">{mensaje}</pre>
        </div>
    );
}
